module.exports = __webpack_public_path__ + "9fdcf7a65de241b4f25ec0ccff7f3e1d.png";


//////////////////
// WEBPACK FOOTER
// ./shared/components/Logo/assets/beige/adusad.png
// module id = 2385
// module chunks = 0